import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'app-dots-loader',
  templateUrl: './dots-loader.component.html',
  styleUrls: ['./dots-loader.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DotsLoaderComponent {}
